/* eslint-disable no-unused-vars */
import { useState } from "react";
import { createUserWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { ref, set } from "firebase/database";
import { auth, database } from "../firebase";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const SetUserPasswordPage = () => {
  const [email, setEmail] = useState(new URLSearchParams(window.location.search).get("email"));
  const [companyId, setCompanyId] = useState(new URLSearchParams(window.location.search).get("companyId"));
  const [role, setRole] = useState(new URLSearchParams(window.location.search).get("role"));
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const provider = new GoogleAuthProvider();

  const handleSubmit = async () => {
    if (password === confirmPassword) {
      setIsLoading(true);
      try {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const authUser = userCredential.user;
        const userRef = ref(database, "users/" + authUser.uid);
        await set(userRef, {
          email: authUser.email,
          uid: authUser.uid,
          companyId: companyId,
          role: role,
          createdAt: new Date().toISOString(),
          isActive: true,
        });
        toast.success("Created Successfully.");
        navigate("/");
      } catch (error) {
        toast.error("Error creating user.");
      } finally {
        setIsLoading(false);
      }
    } else {
      toast.error("Passwords do not match");
    }
  };

  const handleGoogleSignUp = async () => {
    try {
      setIsLoading(true);
      const result = await signInWithPopup(auth, provider);
      const authUser = result.user;
      const userRef = ref(database, "users/" + authUser.uid);
      await set(userRef, {
        email: authUser.email,
        uid: authUser.uid,
        companyId: companyId || "GoogleSignUp",
        role: role || "User",
        createdAt: new Date().toISOString(),
        isActive: true,
      });
      toast.success("Signed up with Google successfully.");
      navigate("/");
    } catch (error) {
      toast.error("Error signing up with Google.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-sm">
        <h2 className="text-center text-2xl text-blue-600 font-semibold mb-4">Set New Password</h2>
        <input type="email" placeholder="Email" value={email} className="w-full p-3 border border-gray-300 rounded-md mb-4" disabled />
        <input type="password" placeholder="New Password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md mb-4" />
        <input type="password" placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="w-full p-3 border border-gray-300 rounded-md mb-4" />
        <button onClick={handleSubmit} className="w-full bg-blue-500 text-white py-2 rounded-lg mt-4 hover:bg-blue-600 disabled:opacity-50" disabled={isLoading}>
          {isLoading ? "Submitting..." : "Submit"}
        </button>
        <div>
          <span>OR</span>
        </div>
        <button onClick={handleGoogleSignUp} className="w-full bg-red-500 text-white py-2 rounded-lg mt-4 hover:bg-red-600 disabled:opacity-50" disabled={isLoading}>
          {isLoading ? "Signing up..." : "Sign Up with Google"}
        </button>
      </div>
    </div>
  );
};

export default SetUserPasswordPage;
